import { FeatureService, MemberStore, SelfServiceStore } from '@web/service';
import { computed, inject, Injectable } from '@angular/core';
import { MenuItemState } from '../../../routes/routes.model';

@Injectable()
export class SideNavigationRouteMenuItemState {
  #store = inject(MemberStore);
  #selfService = inject(SelfServiceStore);
  #selfServiceDisabled = !inject(FeatureService).isFeatureEnabled('selfService');
  menuItemStates = computed<(path: string) => MenuItemState>(() => {
    const policyState = this.#store.policyState();
    const definitelyNoSelfServiceActions =
      this.#selfService.selfServiceActions.value()?.length === 0 && !this.#selfService.selfServiceActions.isLoading();
    const result: Record<string, MenuItemState> = {
      home: policyState?.['hasOrWillHaveActiveVersion'] ? 'enabled' : 'hidden',
      savings: policyState?.['hasAnyCoverCollection'] ? 'enabled' : 'hidden',
      risks: policyState?.['hasOrWillHaveActiveVersion'] ? 'enabled' : 'hidden',
      payout: 'enabled',
      document: 'enabled',
      'self-service': this.#selfServiceDisabled || definitelyNoSelfServiceActions ? 'hidden' : 'enabled',
    };
    return (path: string) => result[path];
  });
}
